import L from "leaflet";
import { SystemConstant, AppConstant, EventConstant } from "const";
import { getShipTypeColor, getShipFishingColor, convertCoordinates } from "utils";
import { useMapContext } from "./useMapContext";
import ShipActions from "redux-store/ship.redux";
import { useDispatch } from "react-redux";
import { EventBus } from "EventBus";

export const useCanvasMarker = () => {
  const { canvasLayerRef, setHoverShip, placeholderCanvasLayerRef, setClickedShip, setShowMenuLayer } = useMapContext();
  const dispatch = useDispatch();

  const clear = () => {
    if (canvasLayerRef.current) {
      canvasLayerRef.current?._markers.forEach(marker => marker.closePopup());
      canvasLayerRef.current.clear();
    }
  };

  const refresh = () => {
    if (canvasLayerRef.current) {
      canvasLayerRef.current.redraw();
    }
  };

  const createIcon = (course, speed, width, length, color, violationF, isFloater = false, isSourceFishing = false) => {
    color = violationF ? "red" : color;
    let scaleSize;
    if (length <= 20 || !length) {
      scaleSize = 0.9;
    } else if (length > 20 && length <= 50) {
      scaleSize = 1;
    } else if (length > 50 && length <= 100) {
      scaleSize = 1.1;
    } else if (length > 100 && length <= 200) {
      scaleSize = 1.2;
    } else if (length > 200 && length <= 300) {
      scaleSize = 1.3;
    } else {
      scaleSize = 1.4;
    }

    return isFloater
      ? L.icon({
          iconSize: [16, 16],
          iconAnchor: [8, 8],
          iconUrl:
            "data:image/svg+xml;base64," +
            btoa(
              `<svg viewBox="0 0 201.26 201.26" xmlns="http://www.w3.org/2000/svg">
                <path fill="rgba(255, 0, 0, 1)" d="M100.63 0L0 100.63l100.63 100.63 100.63-100.63L100.63 0zm0 194.178L7.09 100.631 100.63 7.09l93.548 93.541-93.548 93.547z"></path>
                <path fill="rgba(255, 0, 0, .3)" d="M100.629 194.177l-93.54-93.546L100.63 7.089l93.547 93.54z"></path>
                <path fill="rgba(255, 0, 0, .6)" d="M114.808 86.459c-7.834-7.828-20.523-7.828-28.349 0-7.828 7.825-7.828 20.514.001 28.349 7.825 7.832 20.514 7.832 28.348 0 7.832-7.835 7.832-20.523 0-28.349zm-22.687 22.666c-4.689-4.689-4.688-12.3.001-17.003 4.703-4.689 12.313-4.689 17.002 0 4.713 4.705 4.713 12.314.001 17.003-4.689 4.711-12.3 4.711-17.004 0z"></path>
              </svg>`,
            ),
        })
      : (course === null || course <= 0) && (speed === null || speed <= 0)
        ? L.icon({
            iconSize: [16, 16],
            iconAnchor: [8, 8],
            iconUrl:
              "data:image/svg+xml;base64," +
              btoa(
                `<svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="12" fill="${color}" stroke="#FF0000" stroke-width="1"></circle>
                </svg>`,
              ),
          })
        : isSourceFishing
          ? L.icon({
              iconSize: [10 * scaleSize, 23 * scaleSize],
              iconAnchor: [5, 12],
              rotationAngle: course,
              iconUrl:
                "data:image/svg+xml;base64," +
                btoa(
                  `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="130" height="330" viewBox="0 0 130 330" xml:space="preserve">
                  <desc>Created with Fabric.js 5.2.4</desc>
                  <defs>
                  </defs>
                  <g transform="matrix(1 0 0 1 65 165)" id="4544752d-9f9f-48f1-9fa1-7410805f1603">
                  <rect style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1; visibility: hidden;" vector-effect="non-scaling-stroke" x="-65" y="-165" rx="0" ry="0" width="130" height="330"/>
                  </g>
                  <g transform="matrix(Infinity NaN NaN Infinity 0 0)" id="2fe8c20f-2150-4386-a1d6-5b7fe8362634">
                  </g>
                  <g transform="matrix(12.6 0 0 12.6 65 165)" id="fe1e15cf-cf65-4e60-b504-6d0e59e14d6b">
                  <path style="stroke: ${color}; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: ${color}; fill-rule: nonzero; opacity: 1;" vector-effect="non-scaling-stroke" transform=" translate(-12.34, -12.5)" d="M 11.621094 1.007812 C 9.914062 2.753906 8.484375 5.585938 7.921875 8.351562 C 7.558594 10.117188 7.492188 11.4375 7.546875 14.980469 C 7.585938 16.804688 7.664062 19.328125 7.726562 20.59375 C 7.8125 22.695312 7.84375 22.910156 8.015625 23.039062 C 8.15625 23.132812 8.203125 23.28125 8.203125 23.640625 L 8.203125 24.109375 L 9.0625 24.140625 C 9.875 24.171875 9.914062 24.179688 9.941406 24.40625 C 9.980469 24.640625 9.992188 24.640625 10.773438 24.570312 C 11.210938 24.539062 12.265625 24.511719 13.117188 24.511719 C 14.578125 24.511719 14.667969 24.5 14.71875 24.316406 C 14.765625 24.140625 14.851562 24.121094 15.632812 24.121094 L 16.503906 24.121094 L 16.503906 23.59375 C 16.503906 23.164062 16.53125 23.054688 16.6875 23.015625 C 16.855469 22.976562 16.875 22.8125 16.945312 21.035156 C 16.972656 19.960938 17.023438 18.71875 17.039062 18.261719 C 17.167969 15.28125 17.195312 11.75 17.101562 10.710938 C 16.71875 6.75 15.4375 3.59375 13.234375 1.203125 C 12.820312 0.75 12.421875 0.390625 12.351562 0.390625 C 12.285156 0.390625 11.953125 0.664062 11.621094 1.007812 Z M 13.476562 9.953125 L 14.109375 10.007812 L 14.316406 11.085938 C 14.433594 11.671875 14.5 12.1875 14.460938 12.21875 C 14.433594 12.246094 13.925781 12.234375 13.339844 12.1875 C 12.714844 12.140625 11.882812 12.140625 11.289062 12.1875 C 10.75 12.234375 10.273438 12.246094 10.234375 12.21875 C 10.203125 12.1875 10.265625 11.671875 10.382812 11.085938 L 10.59375 10.007812 L 11.179688 9.953125 C 11.984375 9.875 12.714844 9.875 13.476562 9.953125 Z M 10.03125 10.8125 C 10 10.90625 9.902344 11.40625 9.8125 11.914062 C 9.65625 12.753906 9.472656 13.183594 9.265625 13.183594 C 9.179688 13.183594 9.015625 12.675781 8.925781 12.128906 C 8.859375 11.71875 8.875 11.6875 9.382812 11.171875 C 9.921875 10.625 10.109375 10.527344 10.03125 10.8125 Z M 15.320312 11.203125 L 15.839844 11.757812 L 15.671875 12.46875 C 15.5 13.210938 15.3125 13.378906 15.136719 12.960938 C 15.058594 12.78125 14.648438 10.878906 14.648438 10.703125 C 14.648438 10.546875 14.863281 10.695312 15.320312 11.203125 Z M 13.769531 17.460938 C 13.769531 17.726562 13.828125 18.015625 13.90625 18.117188 C 14.1875 18.507812 14.03125 18.554688 12.34375 18.554688 C 10.996094 18.554688 10.722656 18.535156 10.683594 18.40625 C 10.644531 18.328125 10.664062 18.203125 10.722656 18.132812 C 10.773438 18.078125 10.839844 17.792969 10.867188 17.53125 C 10.898438 17.257812 10.929688 17.03125 10.929688 17.011719 C 10.9375 17 11.570312 16.992188 12.351562 16.992188 L 13.769531 16.992188 Z M 14.523438 20.820312 C 14.578125 20.890625 14.648438 21.269531 14.679688 21.648438 L 14.734375 22.363281 L 9.960938 22.363281 L 10.03125 21.601562 C 10.058594 21.191406 10.136719 20.820312 10.195312 20.78125 C 10.253906 20.742188 11.230469 20.703125 12.363281 20.703125 C 13.90625 20.703125 14.453125 20.734375 14.523438 20.820312 Z M 14.523438 20.820312" stroke-linecap="round"/>
                  </g>
                  </svg>`,
                ),
            })
          : L.icon({
              iconSize: [15 * scaleSize, 20 * scaleSize],
              iconAnchor: [7, 12],
              rotationAngle: course + 16,
              iconUrl:
                "data:image/svg+xml;base64," +
                btoa(
                  `<svg viewBox="0 0 25 45" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.58065 4L2 42L11.0323 34.2712L22 37.4915L4.58065 4Z" fill="${color}" stroke="#FF0000" stroke-width="1"></path>
                </svg>`,
                ),
            });
  };

  const createMarker = (lat, lng, icon, info, isShowShipName = false, shipsAroundRadius = 0) => {
    const marker = L.marker([lat, lng], { icon: icon });
    if (isShowShipName || shipsAroundRadius) {
      if (shipsAroundRadius && !info?.distance) {
        const popup = L.popup({
          closeButton: true,
          keepInView: true,
          autoClose: false,
          closeOnClick: false,
          closeOnEscapeKey: false,
          autoPan: false,
          className: "popup-ship-around",
        }).setContent(
          `Vị trí: ${convertCoordinates(Number(lat), Number(lng))} </br>Bán kính: ${(shipsAroundRadius * AppConstant.METER_TO_NAUTICAL_MILE).toFixed(2)} hải lý`,
        );
        marker.bindPopup(popup);
      } else {
        const popup = L.popup({
          closeButton: !info?.distance,
          keepInView: true,
          autoClose: false,
          closeOnClick: false,
          closeOnEscapeKey: false,
          autoPan: false,
        }).setContent(
          info?.distance ? `${(info?.distance * AppConstant.METER_TO_NAUTICAL_MILE).toFixed(2)} hải lý` : info.name,
        );
        marker.bindPopup(popup);
      }
    }
    marker.on("mouseover", function () {
      const placeholderMarker = L.marker([lat, lng], { icon: L.divIcon() });
      placeholderCanvasLayerRef.current.addLayer(placeholderMarker);
      placeholderMarker.on("mouseover", function (e) {
        setHoverShip({ info: info, event: e.originalEvent });
      });
      placeholderMarker.on("click", function (e) {
        EventBus.emit(EventConstant.POINT_EVENTS.clickMeasure, e);
        setClickedShip({ info: info, event: e.originalEvent });
      });
      placeholderMarker.on("contextmenu", function (e) {
        setShowMenuLayer({ event: e, info: info });
      });
    });
    marker.on("mouseout", function (e) {
      placeholderCanvasLayerRef.current.clearLayers();
      setHoverShip({ info: null, event: null });
    });
    return marker;
  };

  const show = (points = [], isShowShipName, shipsAroundRadius) => {
    clear();
    const markers = points
      ?.filter(point => point)
      .map(point => {
        const isFloater = point.ship_type === SystemConstant.SHIP_TYPE.NAVIGATION_AID ? true : false;
        const marker = createMarker(
          point.ship_lat,
          point.ship_long,
          createIcon(
            point.course,
            point.speed,
            point.width,
            point.length,
            point.source_type === AppConstant.SOURCE_DATA.gstc
              ? getShipFishingColor(point.status)
              : getShipTypeColor(point.ship_type),

            point.violation_f,
            isFloater,
            point.source_type === AppConstant.SOURCE_DATA.gstc,
          ),
          point,
          isShowShipName,
          shipsAroundRadius,
        );
        return marker;
      });

    canvasLayerRef.current.addMarkers(markers);
    if (isShowShipName || shipsAroundRadius) {
      markers.forEach(marker => {
        marker.openPopup();
        marker.on("click", function () {
          marker.openPopup();
        });
      });
      if (shipsAroundRadius) {
        document.querySelector(".popup-ship-around .leaflet-popup-close-button").addEventListener("click", () => {
          dispatch(
            ShipActions.shipSet({
              shipsAround: null,
              shipsAroundCircle: null,
            }),
          );
        });
      }
    }
  };

  const remove = (markers = []) => {
    canvasLayerRef.current.removeMarkers(markers);
  };

  return {
    clear,
    refresh,
    show,
    remove,
  };
};
